export default {
    methods: {
        formatPrefix (prefix) {
            if (prefix.includes('~')) {
                const tildeIndex = prefix.indexOf('~')

                prefix = `${prefix.slice(0, tildeIndex)}<sub>${prefix.slice(tildeIndex + 1, tildeIndex + 2)}</sub>${prefix.slice(tildeIndex + 2, prefix.lenght)}`
            }
            if (prefix.includes('^')) {
                const caretIndex = prefix.indexOf('^')

                prefix = `${prefix.slice(0, caretIndex)}<sup>${prefix.slice(caretIndex + 1, caretIndex + 2)}</sup>${prefix.slice(caretIndex + 2, prefix.lenght)}`
            }

            return prefix
        },
        formatSuffix (suffix) {
            if (suffix.includes('~')) {
                const tildeRegex = /~(.)/g

                suffix = suffix.replace(tildeRegex, '<sub>$1</sub>')
            }
            if (suffix.includes('^')) {
                const caretRegex = /\^(.)/g

                suffix = suffix.replace(caretRegex, '<sup>$1</sup>')
            }

            return suffix
        },
        formatHyperlink (url, textToDisplay) {
            if (!url.startsWith('http://') && !url.startsWith('https://')) {
                url = `https://${url}`
            }

            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${textToDisplay || url}</a>`
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/shared/formatText.js